/* ─── Sidebar (mobile toggle) ──────────────────────────────── */
(function () {
  const toggle = document.getElementById('sidebar-toggle');
  const sidebar = document.getElementById('sidebar');
  if (!toggle || !sidebar) return;

  toggle.addEventListener('click', () => {
    const isOpen = sidebar.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(isOpen));
  });

  document.addEventListener('click', (e) => {
    if (
      sidebar.classList.contains('is-open') &&
      !sidebar.contains(e.target) &&
      !toggle.contains(e.target)
    ) {
      sidebar.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
  });
})();

/* ─── Cart Drawer ──────────────────────────────────────────── */
const Cart = {
  drawer: document.getElementById('cart-drawer'),
  overlay: document.getElementById('cart-overlay'),
  closeBtn: document.getElementById('cart-close'),
  body: document.getElementById('cart-body'),
  footer: document.getElementById('cart-footer'),
  subtotalEl: document.getElementById('cart-subtotal'),
  countEl: document.getElementById('cart-count'),
  upsell: document.getElementById('cart-upsell'),

  open() {
    if (!this.drawer) return;
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.refresh();
  },

  close() {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
  },

  async refresh() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
    } catch (e) {
      console.error('Cart refresh failed', e);
    }
  },

  render(cart) {
    if (!this.body) return;

    if (cart.items.length === 0) {
      this.body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      if (this.footer) this.footer.style.display = 'none';
    } else {
      this.body.innerHTML = cart.items.map(item => `
        <div class="cart-drawer__item">
          ${item.image
            ? `<img src="${this.escapeHtml(this.thumbUrl(item.image))}" alt="${this.escapeHtml(item.title)}" class="cart-drawer__item-img" loading="lazy" width="72" height="72">`
            : '<div class="cart-drawer__item-img"></div>'
          }
          <div>
            <p class="cart-drawer__item-title">${this.escapeHtml(item.product_title.toUpperCase())}</p>
            ${item.variant_title && item.variant_title !== 'Default Title'
              ? `<p class="cart-drawer__item-variant">${this.escapeHtml(item.variant_title)}</p>`
              : ''
            }
            <div class="cart-drawer__item-footer">
              <span class="cart-drawer__item-price">${this.formatMoney(item.final_price)}</span>
              <button class="cart-drawer__item-remove" data-key="${this.escapeHtml(item.key)}">REMOVE</button>
            </div>
          </div>
        </div>
      `).join('');

      if (this.footer) this.footer.style.display = 'block';
      if (this.subtotalEl) this.subtotalEl.textContent = this.formatMoney(cart.total_price);

      this.body.querySelectorAll('[data-key]').forEach(btn => {
        btn.addEventListener('click', () => this.removeItem(btn.dataset.key));
      });
    }

    this.updateShippingBar(cart.total_price);

    /* Add-on offer: only with something in the cart and while it isn't in it yet */
    if (this.upsell) {
      const inCart = cart.items.some(item => String(item.product_id) === this.upsell.dataset.productId);
      this.upsell.hidden = cart.items.length === 0 || inCart;
    }

    this.updateCount(cart.item_count);
  },

  updateShippingBar(total) {
    document.querySelectorAll('[data-free-shipping]').forEach(el => {
      const threshold = Number(el.dataset.threshold);
      if (!threshold) return;
      const remaining = threshold - total;
      el.querySelector('.cart-shipping__text').innerHTML = remaining > 0
        ? `YOU'RE <strong>${this.formatMoney(remaining)}</strong> AWAY FROM FREE SHIPPING`
        : `YOU'VE UNLOCKED FREE SHIPPING ✓`;
      el.querySelector('.cart-shipping__fill').style.width = `${Math.min(100, (total / threshold) * 100)}%`;
      el.classList.toggle('is-complete', remaining <= 0);
    });
  },

  async addUpsell(btn) {
    btn.disabled = true;
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: this.upsell.dataset.variantId, quantity: 1 }),
      });
      await this.refresh();
    } catch (e) {
      console.error('Add-on failed', e);
    }
    btn.disabled = false;
  },

  async removeItem(key) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });
      this.refresh();
    } catch (e) {
      console.error('Remove item failed', e);
    }
  },

  updateCount(count) {
    const countEl = document.getElementById('cart-count');
    if (!countEl) return;
    countEl.textContent = count > 0 ? `(${count})` : '';
  },

  /* Product data is inserted as HTML, so escape it first */
  escapeHtml(value) {
    const map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    return String(value ?? '').replace(/[&<>"']/g, ch => map[ch]);
  },

  /* cart.js returns full-size images; ask the Shopify CDN for a small one */
  thumbUrl(src) {
    try {
      const url = new URL(src, window.location.href);
      url.searchParams.set('width', '160');
      return url.toString();
    } catch (_) {
      return src;
    }
  },

  formatMoney(cents) {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR',
    }).format(cents / 100);
  },

  init() {
    const trigger = document.getElementById('cart-trigger');
    if (trigger) trigger.addEventListener('click', () => this.open());
    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());

    const upsellBtn = document.getElementById('cart-upsell-add');
    if (upsellBtn) upsellBtn.addEventListener('click', () => this.addUpsell(upsellBtn));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  },
};

Cart.init();

/* ─── Add to Cart (AJAX) ───────────────────────────────────── */
(function () {
  const form = document.getElementById('product-form');
  if (!form) return;

  const btn = document.getElementById('add-to-cart');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!btn || btn.disabled) return;

    const variantId = document.getElementById('variant-id')?.value;
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'ADDING...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!res.ok) throw new Error('Add to cart failed');

      btn.textContent = 'ADDED ✓';
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = 'ADD TO CART';
      }, 1500);

      /* Klaviyo: track Added to Cart */
      try {
        const pData = window.YCDProductData;
        if (pData && window._learnq) {
          const variant = pData.variants.find(v => String(v.id) === String(variantId)) || pData.variants[0];
          window._learnq = window._learnq || [];
          window._learnq.push(['track', 'Added to Cart', {
            '$value': variant ? variant.price / 100 : 0,
            'ItemNames': [pData.title],
            'CheckoutURL': '/checkout',
            'Items': [{
              'ProductID': String(pData.id),
              'SKU': variant ? variant.sku : '',
              'ProductName': pData.title,
              'Quantity': 1,
              'ItemPrice': variant ? variant.price / 100 : 0,
              'RowTotal': variant ? variant.price / 100 : 0,
              'ProductURL': window.location.origin + '/products/' + pData.handle,
              'ImageURL': pData.featured_image || '',
              'ProductCategories': pData.type ? [pData.type] : []
            }]
          }]);
        }
      } catch (_) {}

      Cart.open();
    } catch (err) {
      btn.disabled = false;
      btn.textContent = 'ADD TO CART';
      console.error(err);
    }
  });
})();

/* ─── Product Variants ─────────────────────────────────────── */
(function () {
  const productData = window.YCDProductData;
  if (!productData) return;

  const variants = productData.variants;
  const optionBtns = document.querySelectorAll('.product-page__option-btn');
  const optionSelects = document.querySelectorAll('.product-page__option-select');
  if (!optionBtns.length && !optionSelects.length) return;

  let selectedOptions = Array.from(
    document.querySelectorAll('.product-page__option')
  ).map(optEl => {
    const select = optEl.querySelector('.product-page__option-select');
    if (select) return select.value;
    const activeBtn = optEl.querySelector('.product-page__option-btn.is-selected');
    return activeBtn ? activeBtn.dataset.value : null;
  });

  function findVariant(opts) {
    return variants.find(v =>
      opts.every((val, i) => val === null || v[`option${i + 1}`] === val)
    );
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR',
    }).format(cents / 100);
  }

  function updateUI(variant) {
    const priceEl = document.getElementById('product-price');
    const variantIdEl = document.getElementById('variant-id');
    const addBtn = document.getElementById('add-to-cart');
    const lowStockEl = document.getElementById('low-stock-msg');

    if (priceEl && variant) {
      if (variant.compare_at_price > variant.price) {
        priceEl.innerHTML = `
          <span class="product-page__price--was">${formatMoney(variant.compare_at_price)}</span>
          <span class="product-page__price--now">${formatMoney(variant.price)}</span>
        `;
      } else {
        priceEl.innerHTML = `<span>${formatMoney(variant.price)}</span>`;
      }
    }

    if (variantIdEl && variant) variantIdEl.value = variant.id;

    if (addBtn) {
      if (!variant || !variant.available) {
        addBtn.disabled = true;
        addBtn.textContent = 'SOLD OUT';
      } else {
        addBtn.disabled = false;
        addBtn.textContent = 'ADD TO CART';
      }
    }

    if (lowStockEl && variant) {
      const inv = window.YCDInventory && window.YCDInventory[variant.id];
      const qty = inv ? inv.qty : null;
      const tracked = inv ? inv.managed : false;
      if (tracked && qty > 0 && qty < 5) {
        lowStockEl.textContent = `Only ${qty} left — get it fast.`;
        lowStockEl.removeAttribute('hidden');
      } else {
        lowStockEl.setAttribute('hidden', '');
      }
    }
  }

  optionBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const optionIndex = parseInt(btn.dataset.optionIndex, 10);
      const value = btn.dataset.value;

      document.querySelectorAll(
        `.product-page__option-btn[data-option-index="${optionIndex}"]`
      ).forEach(b => b.classList.remove('is-selected'));

      btn.classList.add('is-selected');
      selectedOptions[optionIndex] = value;

      const labelEl = document.getElementById(`option-val-${optionIndex}`);
      if (labelEl) labelEl.textContent = value;

      updateUI(findVariant(selectedOptions));
    });
  });

  optionSelects.forEach(select => {
    select.addEventListener('change', () => {
      selectedOptions[parseInt(select.dataset.optionIndex, 10)] = select.value;
      updateUI(findVariant(selectedOptions));
    });
  });
})();

/* ─── Product Gallery ──────────────────────────────────────── */
(function () {
  const thumbs = document.querySelectorAll('.product-page__thumb');
  const slides = document.querySelectorAll('.product-page__slide');
  if (!slides.length) return;

  let current = 0;
  let leaveTimer = null;

  function goTo(idx) {
    const next = (idx + slides.length) % slides.length;
    if (next === current) return;

    /* Keep the old slide under the new one while it fades in */
    slides.forEach(s => s.classList.remove('is-leaving'));
    slides[current].classList.add('is-leaving');
    slides[current].classList.remove('is-active');
    if (thumbs[current]) thumbs[current].classList.remove('is-active');

    current = next;
    slides[current].classList.add('is-active');
    if (thumbs[current]) thumbs[current].classList.add('is-active');

    clearTimeout(leaveTimer);
    leaveTimer = setTimeout(() => {
      slides.forEach(s => s.classList.remove('is-leaving'));
    }, 300);

    warmNeighbours();
  }

  /* Download the images either side of the current one so the arrows feel instant */
  function warmNeighbours() {
    [current + 1, current - 1].forEach(i => {
      const img = slides[(i + slides.length) % slides.length].querySelector('img');
      if (img) img.loading = 'eager';
    });
  }

  if (slides.length > 1) {
    window.addEventListener('load', warmNeighbours, { once: true });
  }

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      goTo(parseInt(thumb.dataset.index, 10));
    });
  });

  const prevBtn = document.getElementById('gallery-prev');
  const nextBtn = document.getElementById('gallery-next');
  if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));
})();

/* ─── Newsletter (Klaviyo) ─────────────────────────────────── */
(function () {
  async function subscribeEmail(email) {
    try {
      await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Riiy7z', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2023-12-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              list_id: 'USjP4J',
              email: email
            }
          }
        })
      });
    } catch (_) {}
  }

  /* Footer bar */
  const barForm = document.getElementById('newsletter-bar-form');
  const barSuccess = document.getElementById('newsletter-bar-success');
  if (barForm) {
    barForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = document.getElementById('newsletter-bar-email').value.trim();
      if (!email) return;
      await subscribeEmail(email);
      barForm.hidden = true;
      if (barSuccess) barSuccess.removeAttribute('hidden');
      localStorage.setItem('ycd_subscribed', '1');
    });
  }

  /* Popup */
  const popup = document.getElementById('newsletter-popup');
  const popupOverlay = document.getElementById('newsletter-popup-overlay');
  const popupClose = document.getElementById('newsletter-popup-close');
  const popupSkip = document.getElementById('newsletter-popup-skip');
  const popupForm = document.getElementById('newsletter-popup-form');
  const popupSuccess = document.getElementById('newsletter-popup-success');

  if (!popup) return;

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    sessionStorage.setItem('ycd_popup_shown', '1');
  }

  function openPopup() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  /* Show popup after 2.5s unless already subscribed or shown this session */
  const alreadySubscribed = localStorage.getItem('ycd_subscribed');
  const shownThisSession = sessionStorage.getItem('ycd_popup_shown');

  if (!alreadySubscribed && !shownThisSession) {
    setTimeout(openPopup, 2500);
  }

  if (popupOverlay) popupOverlay.addEventListener('click', closePopup);
  if (popupClose) popupClose.addEventListener('click', closePopup);
  if (popupSkip) popupSkip.addEventListener('click', closePopup);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePopup(); });

  if (popupForm) {
    popupForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = document.getElementById('newsletter-popup-email').value.trim();
      if (!email) return;
      await subscribeEmail(email);
      popupForm.hidden = true;
      if (popupSuccess) popupSuccess.removeAttribute('hidden');
      localStorage.setItem('ycd_subscribed', '1');
      setTimeout(closePopup, 2000);
    });
  }
})();

/* ─── Product Modals (size guide / shipping) ──────────────── */
(function () {
  function initModal(triggerId, modalId, overlayId, closeId) {
    const trigger = document.getElementById(triggerId);
    const modal = document.getElementById(modalId);
    const overlay = document.getElementById(overlayId);
    const closeBtn = document.getElementById(closeId);
    if (!trigger || !modal) return;

    function open() {
      /* Images inside modals (size charts) are only downloaded on first open */
      modal.querySelectorAll('img[data-src]').forEach(img => {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      });
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', open);
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  initModal('size-guide-btn', 'size-chart-modal', 'size-chart-overlay', 'size-chart-close');
  initModal('shipping-btn', 'shipping-modal', 'shipping-overlay', 'shipping-close');
})();

/* ─── Cart Page (quantity & remove) ───────────────────────── */
(function () {
  document.querySelectorAll('.cart-item__qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      const action = btn.dataset.action;
      const qtyEl = btn.parentElement.querySelector('.cart-item__qty-val');
      if (!qtyEl) return;

      let qty = parseInt(qtyEl.textContent, 10);
      qty = action === 'increase' ? qty + 1 : Math.max(0, qty - 1);

      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty }),
        });
        window.location.reload();
      } catch (e) {
        console.error(e);
      }
    });
  });

  document.querySelectorAll('.cart-item__remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.key, quantity: 0 }),
        });
        window.location.reload();
      } catch (e) {
        console.error(e);
      }
    });
  });
})();
